module.exports = __webpack_public_path__ + "img/footer-left-preview.00c5cac2.png";